import { setGlobalTheme, type ThemeState, themeStringToObject } from '@atlaskit/tokens';
import { getQueryParams } from '@databases/utils/urls';

const defaultThemeState: Partial<ThemeState> = {
  light: 'light',
  dark: 'dark',
  colorMode: 'light',
};

export function initializeDatabaseTheme() {
  const initialThemeParam = getQueryParams().get('themeState');
  const themeState = initialThemeParam
    ? themeStringToObject(decodeURIComponent(initialThemeParam))
    : defaultThemeState;

  setGlobalTheme(themeState);
}
